module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Вход":"Log in","Входим...":"Logging in...","Войти":"Log in","Восстановить пароль":"Remember password","Регистрация":"Registration","Отмена":"Cancel"}}')
  delete Component.options._Ctor
}
